import { goOffline } from 'firebase/database';
import createDatabaseInstance from './utils/createDatabaseInstance';
import { signOut } from 'firebase/auth';
class DatabaseManager {
    constructor() {
        this.databases = new Map();
        this._consent = "positive";
        this._isSerialNoRegisteredInWarranty = null;
    }
    static getInstance() {
        if (!DatabaseManager.instance) {
            DatabaseManager.instance = new DatabaseManager();
        }
        return DatabaseManager.instance;
    }
    initializeOrGetDatabase(dbType, config, connectionName) {
        if (this.databases.has(connectionName)) {
            // @ts-ignore since we checked if the database exists, we know that it is not null
            return Promise.resolve(this.getDatabase(connectionName));
        }
        const database = createDatabaseInstance(dbType, config);
        this.databases.set(connectionName, database);
        return database.initialize();
    }
    initialize(dbType, config, connectionName) {
        if (this.databases.has(connectionName)) {
            return console.warn(`Database with the name "${connectionName}" has already been initialized`);
        }
        const database = createDatabaseInstance(dbType, config);
        this.databases.set(connectionName, database);
    }
    getDatabase(connectionName) {
        const database = this.databases.get(connectionName);
        if (!database) {
            console.warn(`Database with the name "${connectionName}" has not been initialized`);
            return null;
        }
        return database;
    }
    get isSerialNoRegisteredInWarranty() {
        return this._isSerialNoRegisteredInWarranty;
    }
    set isSerialNoRegisteredInWarranty(value) {
        this._isSerialNoRegisteredInWarranty = value;
        this.databases.forEach((database) => {
            database.isSerialNoRegisteredInWarranty = value;
        });
        if (value)
            this._consent = "positive";
    }
    set consent(value) {
        const finalConsent = this.isSerialNoRegisteredInWarranty ? "positive" : value;
        this._consent = finalConsent;
        this.databases.forEach((database) => {
            database.consent = finalConsent;
        });
    }
    get consent() {
        if (this.isSerialNoRegisteredInWarranty)
            return "positive"; // if the user has registered their serial number in warranty, they have consented to data collection under our T&Cs
        return this._consent;
    }
    // tries to get the database stubbornly, if it fails, it will try again after 1 second
    getDatabaseStubbornly(connectionName, tries = 5) {
        return new Promise((resolve, reject) => {
            const database = this.databases.get(connectionName);
            if (database) {
                return resolve(database);
            }
            if (tries === 0) {
                return reject(`Database with the name "${connectionName}" has not been initialized. Tried ${tries} times.`);
            }
            setTimeout(() => {
                this.getDatabaseStubbornly(connectionName, tries - 1).then(resolve).catch(reject);
            }, 1000);
        });
    }
    async destroyDatabase(connectionName) {
        const database = this.databases.get(connectionName);
        if (!database || !database["db"] || !database["auth"]) {
            console.warn(`Database with the name "${connectionName}" doesn't exist or the db or auth properties are not defined`);
            return false;
        }
        goOffline(database["db"]);
        await signOut(database["auth"]);
        this.databases.delete(connectionName);
        return true;
    }
    async destroyAllDatabases() {
        const databases = this.databases.keys();
        for (const database of databases) {
            await this.destroyDatabase(database);
        }
        return true;
    }
}
export default DatabaseManager;
